export const SET_INTEGRATION_ISSUE_STATUS = "SET_INTEGRATION_ISSUE_STATUS";
export const SET_INTEGRATION_ISSUE_REPORT = "SET_INTEGRATION_ISSUE_REPORT";
